// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';
import { Button } from '../../internal/Button';
import img from '../../static/images/ansarada-tv-image.jpg';

type CtaLink = {|
  text: string,
  href: string,
|};

type BackgroundColors = 'White' | 'Silver' | 'Charcoal' | 'Green' | 'Black';

type PropTypes = {|
  background?: BackgroundColors,
  text?: string,
  ctaLinks: Array<CtaLink>,
  theme?: 'Light' | 'Dark',
|};

const findBestTheme = (background?: BackgroundColors) => {
  switch (background) {
    case 'Green':
    case 'Charcoal':
      return 'Light';
    default: {
      return 'Dark';
    }
  }
};

const TvCta = ({
  background = 'Silver',
  text,
  theme = findBestTheme(background),
  ctaLinks,
}: PropTypes) => (
  <div
    className={cx(
      styles.block,
      background === 'Black' && styles.black,
      background === 'Silver' && styles.silver,
      background === 'Green' && styles.green,
      background === 'Charcoal' && styles.charcoal,
      background === 'White' && styles.white,
    )}
    style={{
      backgroundImage: `url(${img})`,
    }}
  >
    <h4 className={cx(styles.titleText)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 208.69 86.66"
        fill={theme === 'Light' ? '#fff' : '#221f20'}
        className={styles.titleImage}
      >
        <g>
          <g>
            <path d="M20.9,86.11a20.7,20.7,0,1,1,0-41.39H41.59V65.41A20.78,20.78,0,0,1,20.9,86.11Z" />
            <path d="M44.64,41.67V1C67.81,1,85.09,18.5,85.09,41.67Z" />
            <path d="M65.58,85.17c-11.59,0-20.94-8.34-20.94-19.72V44.72H85.09V85.17Z" />
            <circle cx="20.9" cy="20.98" r="20.7" />
            <path d="M109.6,27.2H99.24V18.26H109.6V0h11.27V18.26h17.75V27.2H120.87V66.45a13,13,0,0,0,2.2,7.9q2.21,3,6.74,3a28.16,28.16,0,0,0,5-.39,25.56,25.56,0,0,0,3.95-1l1.94,8.68a39.45,39.45,0,0,1-5.63,1.48,38.57,38.57,0,0,1-7.19.59,21.23,21.23,0,0,1-9.2-1.69,13.68,13.68,0,0,1-5.57-4.79,18.75,18.75,0,0,1-2.79-7.38,57.45,57.45,0,0,1-.71-9.33Z" />
            <path d="M142.89,18.26H156l19.95,54.41,20.34-54.41h12.43l-26.94,67H169.7Z" />
          </g>
        </g>
      </svg>
      <span className={cx(styles.visuallyhidden)}>Tv</span>
    </h4>
    {text && (
      <p
        className={cx(
          styles.blockText,
          theme === 'Light' && styles.whiteText,
          theme === 'Dark' && styles.blackText,
        )}
      >
        {text}
      </p>
    )}
    {ctaLinks.length > 0 && (
      <div className={styles.links}>
        {ctaLinks.map((ctaLink, index) => (
          <Button
            onClick={() => window.open(ctaLink.href, '_self')}
            variant={index % 2 === 0 ? 'Argon' : 'Black'}
          >
            {ctaLink.text}
          </Button>
        ))}
      </div>
    )}
  </div>
);

export default TvCta;
